import { v2 } from '@saucelabs/sl-module-builds';

export const NAMESPACE = 'job-details-build-rdc';

export const buildTypes = v2.common.types.createRDCTypes(NAMESPACE);
